import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Internal_Audit_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

function Internal_Audit_Form({handleClose}) {
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Document Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Document Name</Form.Label>
              <Form.Control placeholder="Enter Name Of Document" />
            </Form.Group>
          </div>

          {/* Start Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Start Date Of Last Internal Audit</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
          </div>

          {/* End Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>End Date Of Last Internal Audit</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
          </div>

          {/* Attached File */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attached File</Form.Label>
              <div className="absolute_fields">
                <Form.Control placeholder="Upload File" disabled />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                </div>
              </div>
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control placeholder="Enter Remark" />
            </Form.Group>
          </div>
        </div>

        {/* Buttons */}
         <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
      </div>
    </section>
  );
}

export default Internal_Audit_Form;
